import localforage from 'localforage'
import axios from 'axios'
export const complaints = {
    state: {
        complaints: null,
        loadingStatus: 'notLoading'
    },
    mutations: {
        SET_COMPLAINTS_LOADING_STATUS(state, status){
            state.loadingStatus = status
        },
        SET_COMPLAINTS(state, content) {
            state.complaints = content
        }
    },
    actions: {
        fetchComplaints({ state, commit }) {
            // prevent multiple requests at same time
            if(state.loadingStatus === 'loading')
                return
            commit('SET_COMPLAINTS_LOADING_STATUS', 'loading')
            return localforage.getItem('authUser').then((headers) => {
                return axios.get( process.env.VUE_APP_API+'complaints', {headers: JSON.parse(headers) })
                .then((response) => {
                    commit('SET_COMPLAINTS', Object.freeze(response.data.data))
                    commit('SET_COMPLAINTS_LOADING_STATUS', 'notLoading')
                    localforage.setItem('complaints', response.data.data)
                })
                .catch(() => {
                    // load from local storage
                    console.log('Reading from local storage');
                    localforage.getItem('complaints').then(deliveries => {
                        commit('SET_COMPLAINTS', Object.freeze(deliveries))
                        commit('SET_COMPLAINTS_LOADING_STATUS', 'notLoading')
                    })
                })
            })
        }
    },
    getters: {
        getComplaints: (state) => {
            if(state.complaints){
                return state.complaints
            }
        },
        getComplaintsLoadingStatus: (state) => {
            return state.loadingStatus
        }
    }
}
